import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const STATS = [{
  value: '15+',
  label: 'Years of craft'
}, {
  value: '400+',
  label: 'Projects delivered'
}, {
  value: '100%',
  label: 'Locally owned'
}];
export function HeroSection() {
  return <section id="top" className="relative isolate flex min-h-[92vh] w-full items-end overflow-hidden bg-pine-950 pb-14 pt-40 sm:pb-20" data-id="element-110" data-mp="ytl7qzyxz5vb">
      <img src="https://cdn.magicpatterns.com/patterns/generated-images/33a287fb-4381-4591-8140-fbea09859085.jpg" alt="Open-concept great room with a stone fireplace, custom millwork, and oak flooring built by Taylor Company" className="absolute inset-0 h-full w-full object-cover" data-id="element-111" data-mp="1mjytk8qxo8hg" />
      <div className="absolute inset-0 bg-gradient-to-t from-pine-950 via-pine-950/55 to-pine-950/15" aria-hidden="true" data-id="element-112" data-mp="1hmfdr4el7nne" />

      <div className="relative mx-auto w-full max-w-[1320px] px-6 lg:px-10" data-id="element-113" data-mp="65fmmc3z7euy">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        ease: [0.16, 1, 0.3, 1]
      }} className="max-w-4xl [text-shadow:0_1px_2px_rgba(3,10,7,0.9),0_4px_30px_rgba(3,10,7,0.85)]" data-id="element-114" data-mp="hnw3wxqkac6o">
          <div className="flex items-center gap-4" data-id="element-115" data-mp="qm7vb1z95e06">
            <span className="h-px w-10 bg-white/80" aria-hidden="true" data-id="element-116" data-mp="log1g2f1rhtc" />
            <p className="text-[11px] font-medium uppercase tracking-widest2 text-white" data-id="element-117" data-mp="10m8hqwsf4a8l">
              Full-Service General Contractor
            </p>
          </div>

          <h1 className="mt-8 font-display text-[3.5rem] font-normal leading-[0.96] tracking-tight text-white sm:text-7xl lg:text-[6rem]" data-id="element-118" data-mp="vlkpy8wd7pdb">
            Design your
            <br data-id="element-119" data-mp="15ertdo7jovar" />
            <span className="italic" data-id="element-120" data-mp="15ea112o07184">dream home</span> today
          </h1>

          <p className="mt-8 max-w-xl text-base font-normal leading-relaxed text-white sm:text-lg" data-id="element-121" data-mp="1jeaz6acvvujw">
            From interiors to exteriors, we design, build, and maintain spaces
            you'll love — with the craftsmanship, discretion, and follow-through
            that discerning homeowners expect.
          </p>

          <div className="mt-11 flex flex-col gap-4 sm:flex-row sm:items-center" data-id="element-122" data-mp="g2lu95x1a50i">
            <a href="#contact" className="group inline-flex h-14 items-center justify-center gap-3 rounded-full bg-bone-50 px-8 text-sm font-medium text-pine-900 transition-colors hover:bg-white" data-id="element-123" data-mp="l0ne3t2aa8d1">
              Request a Quote
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-124" data-mp="zptirwjw4qsb" />
            </a>
            <a href="#work" className="inline-flex h-14 items-center justify-center gap-3 rounded-full border border-white/60 bg-white/5 px-8 text-sm font-medium text-white backdrop-blur-sm transition-colors hover:bg-white/15" data-id="element-125" data-mp="18qrdtpccpnyr">
              View Our Work
            </a>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.4
      }} className="mt-20 flex flex-col gap-10 border-t border-white/25 pt-10 [text-shadow:0_1px_2px_rgba(3,10,7,0.85),0_4px_24px_rgba(3,10,7,0.7)] sm:flex-row sm:items-end sm:justify-between" data-id="element-126" data-mp="330g1k44nn40g">
          <dl className="grid w-full max-w-2xl grid-cols-3 gap-6" data-id="element-127" data-mp="3lxhb8295lsaq">
            {STATS.map(stat => <div key={stat.label} data-id="element-128" data-mp="3gywbe3xtdamt">
                <dt className="sr-only" data-id="element-129" data-mp="3gzxvexwt57go">{stat.label}</dt>
                <dd data-id="element-130" data-mp="3bz9vfmqlpgab">
                  <span className="block font-display text-4xl font-normal text-white sm:text-5xl" data-id="element-131" data-mp="3bys2ayz8ji6m">
                    {stat.value}
                  </span>
                  <span className="mt-2 block text-[11px] uppercase tracking-[0.16em] text-white/80" data-id="element-132" data-mp="380asg7ofjtli">
                    {stat.label}
                  </span>
                </dd>
              </div>)}
          </dl>
        </motion.div>
      </div>
    </section>;
}